(() => {
  document.addEventListener('variant:add', (event) => {
    const productForm = event.target.closest?.('product-form');
    const form = productForm?.querySelector('form');

    if (!form || form.classList.contains('pplr_atc_form') || form.classList.contains('gift-this-product__form')) {
      return;
    }

    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  });
})();
